var map = {
	"./arrow-left-fill.svg": "b2Ow",
	"./arrow-left-small.svg": "p3SW",
	"./arrow-left.svg": "rKfX",
	"./arrow-right-fill.svg": "Z/x4",
	"./arrow-right-small.svg": "cRmq",
	"./arrow-right.svg": "cXxo",
	"./blog/download-guide.svg": "xjaQ",
	"./blog/fullscreen-image_post-hero.svg": "Jkg/",
	"./careers/avatar.svg": "BduK",
	"./careers/hr.svg": "RcCs",
	"./careers/list-sm_en.svg": "RLgO",
	"./careers/list-sm_fr.svg": "49Sb",
	"./careers/list_en.svg": "90pl",
	"./careers/list_fr.svg": "erYr",
	"./consulting/hero.svg": "BU0Y",
	"./consulting/our-services_1.svg": "zwHD",
	"./consulting/our-services_2.svg": "VUF0",
	"./consulting/our-services_3.svg": "Tmbo",
	"./consulting/our-services_4.svg": "bmh3",
	"./consulting/our-services_5.svg": "Y448",
	"./consulting/our-services_6.svg": "I+vT",
	"./consulting/our-services_7.svg": "2eor",
	"./consulting/our-services_8.svg": "HTNP",
	"./consulting/our-services_9.svg": "SV0w",
	"./consulting/projects-your-way_1.svg": "ShJC",
	"./consulting/projects-your-way_2.svg": "vrXz",
	"./consulting/projects-your-way_3.svg": "D+FP",
	"./consulting/working-with-us_1.svg": "dM5E",
	"./consulting/working-with-us_2.svg": "0+48",
	"./facebook-icon-blue.svg": "Wdjt",
	"./facebook-icon.svg": "iAfZ",
	"./hellohr/hero.svg": "RlJW",
	"./hellohr/tree-left.svg": "9svX",
	"./hellohr/tree-owl.svg": "BM/R",
	"./home/chevron-left.svg": "OvUT",
	"./home/chevron-right.svg": "2DOS",
	"./home/tools/complete-bg.svg": "ubbU",
	"./home/tools/complete.svg": "Kkq9",
	"./home/tools/drive-bg.svg": "1AVU",
	"./home/tools/drive.svg": "aPb7",
	"./home/tools/fundamentals-bg.svg": "Hdrm",
	"./home/tools/fundamentals.svg": "RmF9",
	"./home/tools/job-description-generator-bg.svg": "UIHE",
	"./home/tools/job-description-generator.svg": "Dxqv",
	"./home/tools/live-hr-advice-bg.svg": "Uk/y",
	"./home/tools/live-hr-advice.svg": "cLsU",
	"./home/tools/policy-manual-wizard-bg.svg": "xLGs",
	"./home/tools/policy-manual-wizard.svg": "VmXe",
	"./home/tools/surveys-bg.svg": "VHIW",
	"./home/tools/surveys.svg": "8XGV",
	"./home/tools/time-attendance-bg.svg": "ua2n",
	"./home/tools/time-attendance.svg": "DpIb",
	"./home/tools/training-bg.svg": "nH+4",
	"./home/tools/training.svg": "bpQS",
	"./hrdonates/feature_1.svg": "ZzFR",
	"./hrdonates/feature_2.svg": "k50M",
	"./hrdonates/feature_3.svg": "/0EX",
	"./instagram-icon.svg": "5h3D",
	"./linkedin-icon-blue.svg": "LCcC",
	"./linkedin-icon.svg": "PKFe",
	"./logo-footer.svg": "nak5",
	"./logo.svg": "AqYs",
	"./lotus.svg": "CViL",
	"./slogan-footer.svg": "L3Ke",
	"./training/slider/slide_1_en.svg": "QkP6",
	"./training/slider/slide_1_fr.svg": "IJ4s",
	"./training/slider/slide_2_en.svg": "RkJk",
	"./training/slider/slide_2_fr.svg": "j4q5",
	"./training/slider/slide_3_en.svg": "ckBf",
	"./training/slider/slide_3_fr.svg": "8guU",
	"./training/slider/slide_4_en.svg": "wZ6f",
	"./training/slider/slide_4_fr.svg": "Q3Kz",
	"./training/slider/slide_5_en.svg": "Aozc",
	"./training/slider/slide_5_fr.svg": "Qdlu",
	"./training/slider/slide_6_en.svg": "YHuX",
	"./training/slider/slide_6_fr.svg": "4B/y",
	"./training/slider/slide_7_en.svg": "UCd6",
	"./training/slider/slide_7_fr.svg": "C5vE",
	"./training/slider/slide_8_en.svg": "2noi",
	"./training/slider/slide_8_fr.svg": "UYp5",
	"./training/slider/slide_9_en.svg": "lQ4+",
	"./training/slider/slide_9_fr.svg": "DcIV",
	"./twitter-icon-blue.svg": "cbvf",
	"./twitter-icon.svg": "CYqc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B4Oj";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = B4Oj
// module chunks = 0